import { api } from './client';

export interface TradeRecommendation {
    entry: number;
    stop_loss: number;
    take_profit: number[];
    leverage: number;
    position_size_usdt: number;
    risk_usdt: number;
    risk_pct: number;
    rr_ratio: string;
}

export interface AnalysisResult {
    success: boolean;
    symbol: string;
    interval: string;
    direction: 'long' | 'short' | 'wait';
    confidence: number;
    summary: string;
    reasoning: string[];
    signals_bullish: string[];
    signals_bearish: string[];
    trade: TradeRecommendation | null;
    invalidation: string;
    timeframe_bias: Record<string, string>;
    ai_provider?: string;
    cached_at?: number | null;
    error?: string;
}

export async function fetchAnalysis(
    symbol: string,
    interval: string,
    balanceUsdt: number = 100,
): Promise<AnalysisResult> {
    return api.get<AnalysisResult>(
        `/analysis?symbol=${symbol}&interval=${interval}&balance_usdt=${balanceUsdt}`
    );
}

export async function fetchFuturesBalance(): Promise<number> {
    try {
        const data = await api.get<{ success: boolean; available_usdt: number }>(
            '/futures/balance'
        );
        return data.success ? data.available_usdt : 100;
    } catch {
        return 100;
    }
}
